import { produce } from 'immer'
// Action Types
export const SET_ORGANIZATION = 'organizations/setOrganization'
export const SET_AUDIT_EVENTS = 'organizations/setAuditEvents'
export const SET_INTEGRATION_CREDENTIALS = 'organizations/setIntegrationCredentials'

// Action Creators
export const setOrganization = (payload) => ({ type: SET_ORGANIZATION, payload })
export const setOrganizationAuditEvents = (payload) => ({ type: SET_AUDIT_EVENTS, payload })
export const setIntegrationCredentials = (payload) => ({
  type: SET_INTEGRATION_CREDENTIALS,
  payload,
})

// State
export const initialState = {
  ai_checklist_enabled: false,
  ai_library_model_cid: null,
  auditEvents: [],
  integrationCredentials: [],
  call_sentiment_upset_reason_enabled: false,
  call_summarization_enabled: false,
  custom_branding_display_name: null,
  custom_branding_enabled: false,
  custom_branding_theme: null,
  data_access_key: null,
  deleted: false,
  desktop_always_start_call: false,
  desktop_auth_key: null,
  desktop_enterprise_enabled: false,
  desktop_leaderboard_visibility: false,
  desktop_manual_config_selecting: false,
  desktop_visibility: false,
  id: null,
  leaderboard_include_managers: false,
  name: null,
  novel_content_disabled: false,
  omnichannel_enabled: false,
  phrase_matching_model_cid: null,
  playbook_timer: false,
  production: false,
  qa_enabled: false,
  qa_copilot_enabled: false,
  qa_export: false,
  qa_reporting: false,
  realtime_coaching_access: false,
  remote_desktop_key: null,
  requires_compliance: false,
  salesforce_id: null,
  saml_metadata_url: null,
  save_audio: false,
  save_audio_ratio: null,
  show_summarization_notes: false,
  use_smart_phrase_shadow_mode_model: false,
  screen_capture_enabled: false,
  call_data_dump_enabled: false,
  interval_call_data_dump_enabled: false,
  update_call_data_dump_enabled: false,
  uuid: '',
  audio_expiry_days: null,
  postcall_min_duration_minutes: null,
  postcall_max_duration_minutes: null,
  editable_notes_enabled: true,
  agent_gpt_enabled: false,
  session_timeout_enabled: false,
  cid_specific_qaps_enabled: false,
  dynamic_insights_enabled: false,
  mfa_required: false,
  voip_customer_id_blacklist: [],
  content_customization_enabled: true,
  audio_ingestion_only: false,
  tracked_insight_limit: null,
}

// Reducer
export default function organizationReducer(state = initialState, action) {
  return produce(state, (newState) => {
    const { payload, type } = action

    switch (type) {
      case SET_ORGANIZATION:
        newState = payload
        return newState
      case SET_AUDIT_EVENTS:
        newState.auditEvents = payload
        return newState
      case SET_INTEGRATION_CREDENTIALS:
        newState.integrationCredentials = payload
        return newState
      default:
        return newState
    }
  })
}
